<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddFundingOrderFlag" size="50%"
      :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="费用名称" prop="fee_name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.fee_name" placeholder="请输入费用名称" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="项目来源" prop="funding_type" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addFrom.funding_type" @change="getFundingTypeSelect(false)">
                  <el-radio :label="1">自营</el-radio>
                  <el-radio :label="2">分销</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="业务分类" prop="funding_type_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.funding_type_id" placeholder="请选择业务分类" clearable style="width: 85%;">
                    <el-option v-for="dict in fundingTypeList" :key="dict.id"
                      :label="dict.name + '(' + dict.type_text + ')'" :value="dict.id" />
                  </el-select>
                  <img @click="AddPushFundingType"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshFundingType"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="收支类型" prop="trade_type" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addFrom.trade_type" @change="getTradeTypeSelect(false)">
                  <el-radio :label="1">收入</el-radio>
                  <el-radio :label="2">支出</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="收支名称" prop="trade_type_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.trade_type_id" placeholder="请选择收支名称" clearable style="width: 85%;">
                    <el-option v-for="dict in tradeTypeList" :key="dict.id" :label="dict.name" :value="dict.id" />
                  </el-select>
                  <img @click="AddPushTradeType"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshTradeType"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col v-if="!editID" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="交易时间区间" :label-width="formLabelWidth">
                <el-date-picker
                    v-model="TimeInterval"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="TimeData()">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col v-if="!editID" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-for="(item, index) in addFrom.fundsArray"
              :key="index">
              <div style="display: flex;height: 41px;">

                <el-form-item label="交易时间" :prop="'fundsArray.' + index + '.trade_time'" :rules="[{ required: true, message: '请选择交易时间', trigger: 'change' }]" :label-width="formLabelWidth">
                  <el-date-picker v-model="item.trade_time" :picker-options="pickerOptions" type="date" placeholder="选择交易时间" value-format="yyyy-MM-dd"
                    style="width: 292px;">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="交易金额"  :label-width="'110px'" :prop="'fundsArray.' + index + '.amount'" :rules="[{ required: true, message: '请选择交易金额', trigger: 'change' }]">
                  <el-input v-model="item.amount"  placeholder="请输入交易金额"
                    oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                    clearable style="width: 292px"></el-input>
                </el-form-item>
                <!-- 控制新增按钮和删除按钮的显示 -->
                <div v-if="index === 0">
                  <!-- 第一行显示新增按钮 -->
                  <img @click="AddPushList"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xz.png" alt="">
                </div>
                <div v-if="index > 0">
                  <!-- 第二行及以后显示删除按钮 -->
                  <img @click="AddPushDel(index)"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/sc.png" alt="">
                </div>
              </div>
            </el-col>

            <el-col v-if="editID" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="交易金额" prop="amount" :label-width="formLabelWidth">
                <el-input v-model="addFrom.amount" placeholder="请输入交易金额"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          clearable style="width: 85%;"></el-input>
              </el-form-item>

              <el-form-item label="交易时间" prop="trade_time" :label-width="formLabelWidth">
                <el-date-picker v-model="addFrom.trade_time" type="date" placeholder="选择交易时间" value-format="yyyy-MM-dd"
                                style="width: 85%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联团队" prop="team_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.team_id" placeholder="请选择团队" clearable style="width: 85%;">
                    <el-option v-for="dict in teamList" :key="dict.id" :label="dict.name" :value="dict.id" />
                  </el-select>
                  <img @click="AddPushteam"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshteam"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联小说项目" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.short_play_project_id" placeholder="请选择小说项目" clearable filterable
                    style="width: 85%;">
                    <el-option v-for="dict in shortPlayProjectList" :key="dict.id" :label="dict.name"
                      :value="dict.id" />
                  </el-select>
                  <img @click="AddPushShortPlay"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshShortPlay"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联主体" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.subject_id" placeholder="请选择主体" @change="updateSubject" clearable filterable
                    style="width: 85%;">
                    <el-option v-for="dict in subjectList" :key="dict.id" :label="dict.name" :value="dict.id" />
                  </el-select>
                  <img @click="AddPushSubjec"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshSubjec"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联合同" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <el-select v-model="addFrom.contract_id" filterable placeholder="请选择合同" clearable style="width: 85%;">
                    <el-option v-for="dict in contractList" :key="dict.id" :label="dict.name" :value="dict.id" />
                  </el-select>
                  <img @click="AddPushContract"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshContract"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="执行状态" prop="execution_status" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addFrom.execution_status">
                  <el-radio :label="0">未执行</el-radio>
                  <el-radio :label="1">已执行</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="addFrom.execution_status == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="执行时间" prop="execution_time" :label-width="formLabelWidth">
                <el-date-picker v-model="addFrom.execution_time" type="date" placeholder="选择执行时间"
                  value-format="yyyy-MM-dd" style="width: 85%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { MoneyManagementAPI } from '@/api/MoneyManagement/MoneyManagement';
import { processErrors } from "@/utils/errorHandler";
export default {
  props: ['AddFundingOrderFlag', "editID"],
  components: {

  },
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        fee_name: "",
        funding_type: 1,
        funding_type_id: "",
        trade_type: 1,
        trade_type_id: '',
        short_play_project_id: "",
        contract_id: "",
        fundsArray: [
          { trade_time: '', amount: '' }
        ],
        trade_time: "",
        execution_time: "",
        execution_status: 0,
        id: "",
      },
      rules: {
        fee_name: [
          { required: true, message: '请输入费用名称', trigger: 'blur' },
        ],
        // amount: [
        //   { required: true, message: '请输入交易金额', trigger: 'blur' },
        // ],
        // trade_time: [
        //   { required: true, message: '请选择交易时间', trigger: 'change' },
        // ],
        funding_type: [
          { required: true, message: '请选择项目来源', trigger: 'change' },
        ],
        funding_type_id: [
          { required: true, message: '请选择业务分类', trigger: 'change' },
        ],
        trade_type: [
          { required: true, message: '请选择收支类型', trigger: 'change' },
        ],
        trade_type_id: [
          { required: true, message: '请选择收支名称', trigger: 'change' },
        ],
        team_id: [
          { required: true, message: '请选择团队', trigger: 'change' },
        ],
        execution_status: [
          { required: true, message: '请选择执行状态', trigger: 'change' }
        ],
        execution_time: [
          { required: true, message: '请选择执行时间', trigger: 'change' }
        ],
       
      },
      fundingTypeList: [],
      tradeTypeList: [],
      shortPlayProjectList: [],
      contractList: [],
      teamList: [],
      subjectList: [],
      TimeInterval: [],
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
    };
  },
  created() {
    this.getShortPlayProjectSelect();
    this.getTeamSelect()
    this.getSubjectSelect()
  },
  methods: {

    disabledDate(time) {
      // 获取本地时间的年、月、日
      const year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始
      const day = time.getDate().toString().padStart(2, '0');

      // 格式化为 YYYY-MM-DD
      const formattedDate = `${year}-${month}-${day}`;

      // 检查是否在禁用的日期数组中
      return this.addFrom.fundsArray.some(item => item.trade_time === formattedDate);
    },

    TimeData(){
      if(this.TimeInterval){
        const dates = this.getDateRange(this.TimeInterval[0],this.TimeInterval[1])
        // 使用 map（如果需要生成新数组）
        dates.map((date) => {
          this.addFrom.fundsArray.push({ trade_time: date, amount: '' });
        });
        this.addFrom.fundsArray = this.addFrom.fundsArray.filter(item => item.trade_time !== "" || item.amount !== "");
      }else{
        this.addFrom.fundsArray = [
          { trade_time: '', amount: '' }
        ]
      }
    },

    getDateRange(startDate, endDate) {
      const dates = [];
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 将开始和结束日期调整为北京时间
      start.setHours(start.getHours() + 8); // UTC+8
      end.setHours(end.getHours() + 8); // UTC+8

      // 循环从开始日期到结束日期
      for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
        // 将当前日期格式化为 ISO 字符串或其他格式
        dates.push(d.toISOString().split('T')[0]); // 只保留日期部分
      }

      return dates;
    },

    AddPushList() {
      // 向表单项数组中添加一个新的表单对象
      this.addFrom.fundsArray.push({ trade_time: '', amount: '' });
      // 动态添加验证规则，确保每个新增项有对应的验证规则
      const index = this.addFrom.fundsArray.length - 1;
    },
    AddPushDel(index) {
      // 确保删除操作是合法的（防止删除第一行）
      if (this.addFrom.fundsArray.length > 1) {
        // 移除指定项
        this.addFrom.fundsArray.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行数据');
      }
    },
    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          this.subjectList = res.data

        } else {
          processErrors(res);
        }
      })
    },

    getFundingTypeSelect(isEdit) {
      let api = MoneyManagementAPI()
      api.getFundingTypeSelect({ type: this.addFrom.funding_type }).then(res => {
        if (res.code == 0) {
          if (!isEdit) {
            this.addFrom.funding_type_id = null
          }
          this.fundingTypeList = res.data

        } else {
          processErrors(res);
        }
      })
    },

    getTradeTypeSelect(isEdit) {
      let api = MoneyManagementAPI()
      api.getTradeTypeSelect({ type: this.addFrom.trade_type }).then(res => {
        if (res.code == 0) {
          if (!isEdit) {
            this.addFrom.trade_type_id = null
          }
          this.tradeTypeList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    getShortPlayProjectSelect() {
      let api = MoneyManagementAPI()
      api.getShortPlayProjectSelect().then(res => {
        if (res.code == 0) {
          this.shortPlayProjectList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    getContractSelect(subject_id) {
      this.contractList = [];
      let api = MoneyManagementAPI()
      api.getContractSelect({ subject_id: subject_id }).then(res => {
        if (res.code == 0) {
          this.contractList = res.data

        } else {
          processErrors(res);
        }
      })
    },

    getTeamSelect() {
      let api = MoneyManagementAPI()
      api.getTeamSelect().then(res => {
        if (res.code == 0) {
          this.teamList = res.data

        } else {
          processErrors(res);
        }
      })
    },

    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        execution_status: "",
        subject_id: '',
        id: "",
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.addFrom.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }

          let api = MoneyManagementAPI()
          api.fundingOrderAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });

    },
    AddPushteam() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/team';
      window.open(url);

    },
    AddRefreshteam() {
      this.getTeamSelect()
    },
    AddPushShortPlay() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/ShortPlayProject';
      window.open(url);
    },
    AddRefreshShortPlay() {
      this.getShortPlayProjectSelect()
    },
    AddPushSubjec() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/subject';
      window.open(url);
    },
    AddRefreshSubjec() {
      this.getSubjectSelect()
    },
    AddPushContract() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/contract';
      window.open(url);

    },
    AddRefreshContract() {
      this.getContractSelect(this.addFrom.subject_id ? this.addFrom.subject_id : '')
    },
    AddPushTradeType() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/IncomeExpenditureType';
      window.open(url);

    },
    AddRefreshTradeType() {
      this.getTradeTypeSelect()
    },
    AddPushFundingType() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/FundingType';
      window.open(url);
    },
    AddRefreshFundingType() {
      this.getFundingTypeSelect()
    },
    updateSubject(e){
      this.addFrom.contract_id = ''
      this.getContractSelect(e)
    }
  },

  mounted() {
    if (this.editID != "") {
      let api = MoneyManagementAPI()
      api.fundingOrderInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          if (res.data.short_play_project_id == 0) {
            res.data.short_play_project_id = ""
          }
          if (res.data.contract_id == 0) {
            res.data.contract_id = ""
          }
          if (res.data.execution_time == '0000-00-00 00:00:00') {
            res.data.execution_time = ""
          }
          this.addFrom = res.data
          if (res.data.subject_id == 0) {
            this.addFrom.subject_id = ""
          }
          this.getTradeTypeSelect(true)
          this.getFundingTypeSelect(true)
          this.getContractSelect(this.addFrom.subject_id ? this.addFrom.subject_id : '')
        } else {
          processErrors(res);
        }
      })

      this.rules.amount = [
        { required: true, message: '请输入交易金额', trigger: 'blur' },
      ]
      this.rules.trade_time = [
        { required: true, message: '请选择交易时间', trigger: 'change' },
      ]
    } else {
      this.getFundingTypeSelect(true)
      this.getTradeTypeSelect(true)
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px;
  /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>